import { GeoCoords } from 'common/utils/Map';
import slice from '../reducer/slice';

const { setUserGeoPosition } = slice.actions;

type Operation = (cords: GeoCoords) => void;

const operation: Operation = (cords) => setUserGeoPosition(cords);

export default operation;
